import { applicationTypeVerifyPrompt } from './applicationTypeVerifyPrompt';
export const applicationTypeRegeneratePrompt = applicationTypeVerifyPrompt.ai('FALSE').human('Return correct type.');
//# sourceMappingURL=applicationTypeRegeneratePrompt.js.map